export const referralsRewardItems = [
  // {
  //   name: "Airtime",
  //   tag: "GHS 2",
  //   id: "airtime",
  //   points: 100,
  //   image: "/assets/images/airtime_guy.png",
  // },
  // {
  //   name: "100 MB Data",
  //   tag: "GHS 50",
  //   id: "data-100",
  //   points: 200,
  //   image: "/assets/images/data_lady.png",
  // },
  {
    name: "Shoprite Voucher",
    tag: "GHS 100",
    id: "shoprite-voucher",
    points: 2500,
    image: "/assets/images/shopritemw.jpg",
  },
  {
    name: "Melcom Voucher",
    tag: "GHS 100",
    id: "melcom-voucher",
    points: 2500,
    image: "/assets/images/melcomemw.jpg",
  },
  {
    name: "KFC",
    tag: "GHS 100",
    id: "kfc-voucher",
    points: 2500,
    image: "/assets/images/kfcmw.jpg",
  },
];
